
import type { PropType } from 'vue'
import Vue from 'vue'
import type {
  TooltipProp,
  Position,
} from 'vue-slider-component/typings/typings'
import VueSlider from 'vue-slider-component'
import type { WithRefs } from 'vue-typed-refs'

import type { VueComponentListeners } from '@/types'

import { uid } from '../../utils'
import WeveFormControlLabel from '../FormControlLabel/FormControlLabel.vue'

export default (
  Vue as WithRefs<{ slider: InstanceType<typeof VueSlider> }>
).extend({
  name: 'WeveSlider',
  inheritAttrs: false,
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    label: {
      type: String,
      required: true,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: uid,
    },
    height: {
      type: Number,
      default: 4,
    },
    dotSize: {
      type: Number,
      default: 16,
    },
    tooltip: {
      type: String as PropType<TooltipProp>,
      default: 'always',
    },
    tooltipPlacement: {
      type: String as PropType<Position>,
      default: 'top',
    },
  },
  computed: {
    listeners(): VueComponentListeners {
      return {
        ...this.$listeners,
        change: (val: number) => this.$emit('input', val),
      }
    },
  },
  methods: {
    onLabelClick() {
      this.$refs.slider.focus()
    },
  },
  render(h) {
    return h('div', { staticClass: 'weve-slider' }, [
      h(
        WeveFormControlLabel,
        {
          attrs: { for: this.id },
          staticClass: 'weve-slider__label',
          class: {
            'sr-only': this.noLabel,
          },
          on: {
            click: this.onLabelClick,
          },
        },
        this.label,
      ),
      h(VueSlider, {
        ref: 'slider',
        props: {
          ...this.$attrs,
          value: this.value,
          height: this.height,
          dotSize: this.dotSize,
          tooltip: this.tooltip,
          tooltipPlacement: this.tooltipPlacement,
          dotAttrs: {
            id: this.id,
          },
        },
        on: this.listeners,
      }),
    ])
  },
})
